import { Link } from "gatsby"
import styled from "styled-components"

const fullWidth = "2.5rem"
const smallWidth = "1.25rem"

export const Wrapper = styled.div`
  background: rgb(0, 0, 0);
  /* background: linear-gradient(
    90deg,
    rgba(0, 0, 0, 0.5) 60%,
    rgba(255, 255, 255, 0) 100%
  ); */
  background: radial-gradient(
    circle at -16%,
    rgba(0, 0, 0, 0.7) 0%,
    rgba(0, 0, 0, 0.6) 15%,
    rgba(0, 0, 0, 0) 20%
  );
  background-size: 300%;
  width: 100vw;
  height: 100vh;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 20;
  pointer-events: none;
  transition: 1s;
  ${({ isHideSidebar }) =>
    isHideSidebar &&
    `
    background: transparent !important;
    pointer-events: none;
  `};
`

export const NavList = styled.ul`
  display: flex;
  align-items: center;
  flex-direction: column;
  width: ${fullWidth};
  margin: 4rem auto;
  margin-left: 10vw;

  background-color: rgba(255, 255, 255, 0.1);
  border-radius: ${smallWidth};
  padding: calc(${smallWidth} / 2) 0;
  transition: transform 1s;
  pointer-events: all;
  transform: ${({ isHideSidebar }) =>
    isHideSidebar ? "translateX(-30rem)" : "translateX(-5rem)"};
`

export const NavElement = styled.li`
  display: flex;
  align-items: center;
  justify-content: space-between;
`

export const Indicator = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  width: ${fullWidth};
  height: ${fullWidth};
  background-color: ${({ theme }) => theme.palette.neutral.light};
  transform: translate(-50%, -50%);
  border-radius: 50%;
  opacity: 0;
  transition: opacity 0.3s ease-in;
`

export const NavLink = styled(Link)`
  width: ${smallWidth};
  height: ${smallWidth};
  margin: ${fullWidth} auto;
  border: 1px solid ${({ theme }) => theme.palette.neutral.light};
  border-radius: 50%;
  position: relative;
  display: flex;
  align-items: center;
  color: ${({ theme }) => theme.palette.neutral.light};
  opacity: 0.7;

  &.active {
    opacity: 1;
    ${Indicator} {
      opacity: 1;
    }
  }

  &:before {
    content: "${({ before }) => before}";
    display: block;
    position: absolute;
    right: calc(${fullWidth} * 1.2);
    ${({ theme }) => theme.textStyles.sidebarNumber}
  }
  &:after {
    content: "${({ after }) => after}";
    display: block;
    position: absolute;
    left: calc(${fullWidth} * 1.2);
    width: 6rem;
    ${({ theme }) => theme.textStyles.sidebarLabel}
  }
`

export const Logo = styled.img`
  width: 5rem;
  margin-left: 3.5rem;
  margin-top: 3rem;
  pointer-events: all;
`
